import {Injectable} from '@angular/core';
import {BarrierefreiheitService} from './barrierefreiheit.service';
import {BarrierefreiheitTastenbelegungService} from './tastenbelegung.service';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class BarrierefreiheitTextanpassungService {

  constructor(
    public barrierefreiheitService: BarrierefreiheitService,
    private test: BarrierefreiheitTastenbelegungService
  ) {
  }

  public textGroesseAendern(textGroesse){
    this.barrierefreiheitService.neuesForm ? this.barrierefreiheitService.neuesForm.next(textGroesse) : false;
    const rootStyle = document.documentElement.style;
    if (rootStyle.getPropertyValue('--global-font-size')) {
      rootStyle.removeProperty('--global-font-size');
    }
    rootStyle.setProperty('--global-font-size', (textGroesse + 'px'));
  }
}

